<template>
  <section class="section-graphs" :style="cssVars">
    <div v-show="graphActive === 0" class="graph graph-pie">
      <div class="chart-list">
        <div class="chart-item" v-show="showChannelMetadataType" ref="channelMetadataTypeContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsByChannelMetadataType`) }}</span> <span class="chart-title-b text-blue">{{ getSumOfStatsValues(leadsStatisticChannelMetadataType) }}</span>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticChannelMetadataTypeChartData"
                :options="generatePieChartOptions($refs.byChannelMetadataTypeChart, ChartType.LeadsChannelMetadataType)"
                ref="byChannelMetadataTypeChart" />
          </div>
          <div class="chart-labels">
            <div v-for="(item, index) in leadsStatisticChannelMetadataTypeChartData.labels" :key="item" class="chart-label">
              <span class="color" v-if="leadsStatisticChannelMetadataTypeChartData.datasets"
                    :style="{ backgroundColor: leadsStatisticChannelMetadataTypeChartData.datasets[0].backgroundColor[index] }"></span>
              <span class="txt" @click="onGraphLabelClick(ChartType.LeadsChannelMetadataType, item)">
                {{ getChartLabelText(item) }}
              </span>
            </div>
          </div>
        </div>
        <div class="chart-item" v-show="showCampaignNameInLeads" ref="leadsByCampaignsContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsByCampaigns`) }}</span> <span class="chart-title-b text-blue">{{ getSumOfStatsValues(leadsStatisticByCampaigns) }}</span>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticByCampaignsChartData"
                :options="generatePieChartOptions($refs.byCampaignsChart, ChartType.LeadsCampaigns)"
                ref="byCampaignsChart" />
          </div>
        </div>
        <div class="chart-item" ref="leadsByCallStatusContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsByCallStatus`) }}</span> <span class="chart-title-b text-blue">{{ getSumOfStatsValues(leadsStatisticByCallStatus) }}</span>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticByCallStatusChartData"
                :options="generatePieChartOptions($refs.byCallStatusChart, ChartType.LeadsCallStatus)"
                ref="byCallStatusChart" />
          </div>
          <div class="chart-labels">
            <div v-for="item in leadsStatisticByCallStatus" :key="item.Text" class="chart-label">
              <span class="color" :style="{ backgroundColor: item.Color }"></span>
              <span class="txt" @click="onGraphLabelClick(ChartType.LeadsCallStatus, item.Text)">{{ item.Text }}</span>
            </div>
          </div>
        </div>
        <div class="chart-item" ref="leadsByPhoneAndFormsContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsByPhoneAndForms.Title`) }}</span>
            <span class="chart-title-b text-blue">{{ getSumOfStatsValues(leadsStatisticByPhoneAndForms) }}</span>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticByPhoneAndFormsChartData"
                :options="generatePieChartOptions($refs.byPhoneAndFormsChart, ChartType.LeadsPhoneAndForms)"
                ref="byPhoneAndFormsChart" />
          </div>
          <div class="chart-labels">
            <div v-for="item in leadsStatisticByPhoneAndForms" :key="item.Text" class="chart-label">
              <span class="color" :style="{ backgroundColor: item.Color }"></span>
              <span class="txt" @click="onGraphLabelClick(ChartType.LeadsPhoneAndForms, item.Text)">{{ item.Text }}</span>
            </div>
          </div>
        </div>
        <div v-show="pageKind" class="chart-item" ref="leadsBySaleStatusContainer">
          <div class="chart-titles">
            <div class="chart-title">
              <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsBySaleStatus.TotalMeetings`) }}</span>
              <span class="chart-title-b text-yellow">
                {{ getTotalMeetingCountOfLeadsStatisticDealMeetingsLeads() }}
                <b-tooltip position="is-bottom" type="is-dark">
                  <span class="chart-help">
                    <icon-base width="14" height="14" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
                  </span>
                <template #content>
                  <p>{{ $t("LeadsGraphs.LeadsBySaleStatus.TotalMeetingsTooltip") }}</p>
                </template>
              </b-tooltip>
                </span>
            </div>
            <div class="chart-title chart-title-second">
              <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsBySaleStatus.TotalDeals`) }}</span>
              <span class="chart-title-b text-green">{{ getTotalDealCountOfLeadsStatisticDealMeetingsLeads() }}
                <b-tooltip position="is-bottom" type="is-dark">
                  <span class="chart-help">
                    <icon-base width="14" height="14" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
                  </span>
                  <template #content>
                    <p>{{ $t("LeadsGraphs.LeadsBySaleStatus.NumberOfDeals") }}</p>
                  </template>
                </b-tooltip>
                <span class="chart-title-sm">({{ $t("LeadsGraphs.LeadsBySaleStatus.TotalDealAmounts", { DEAL_AMOUNT: getTotalAmountOfLeadsStatisticDealMeetingsLeads() }) }}
                  <b-tooltip position="is-bottom" type="is-dark">
                    <span class="chart-help">
                      <icon-base width="14" height="14" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
                    </span>
                    <template #content>
                      <p>{{ $t("LeadsGraphs.LeadsBySaleStatus.TotalDealAmountsTooltip", { DEAL_AMOUNT: getTotalAmountOfLeadsStatisticDealMeetingsLeads() }) }}</p>
                    </template>
                  </b-tooltip>)
                </span>
              </span>
            </div>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticBySaleStatusChartData"
                :options="generatePieChartOptions($refs.bySaleStatusChart, ChartType.LeadsSaleStatus)"
                ref="bySaleStatusChart" />
          </div>
          <div class="chart-labels">
            <div v-for="item in leadsStatisticBySaleStatus" :key="item.Text" class="chart-label">
              <span class="color" :style="{ backgroundColor: item.Color }"></span>
              <span class="txt" @click="onGraphLabelClick(ChartType.LeadsSaleStatus, item.Text)">{{ item.Text }}</span>
            </div>
          </div>
        </div>
        <div v-show="pageKind" class="chart-item" ref="leadsByAdditionalStatusContainer">
          <div class="chart-title">
            <span class="chart-title-t">{{ $t(`${kindPrefix}.Graphs.LeadsByAdditionalStatus`) }}</span> <span class="chart-title-b text-blue">{{ getSumOfStatsValues(leadsStatisticByAdditionalStatus) }}</span>
          </div>
          <div class="chart-container">
            <LeadsGraphPie :width="164" :height="164" :chart-data="leadsStatisticByAdditionalStatusChartData"
                :options="generatePieChartOptions($refs.byAdditionalStatusChart, ChartType.LeadsAdditionalStatus)"
                ref="byAdditionalStatusChart" />
          </div>
        </div>
      </div>
    </div>
    <mq-layout v-show="graphActive === 1" class="graph graph-line" mq="lg">
      <div class="chart-item" ref="dealMeetingsLeadsContainer">
        <div class="chart-labels">
          <div class="chart-label">
            <span class="color has-background-primary"></span>
            <span class="txt">{{ $t(`${kindPrefix}.Graphs.DealMeetingsLeads.TotalLeads`) }} {{ leadsStatisticDealMeetingsLeadsChartData.totalLeads }}</span>
          </div>
          <div v-show="pageKind" class="chart-label">
            <span class="color has-background-warning"></span>
            <span class="txt">{{ $t(`${kindPrefix}.Graphs.DealMeetingsLeads.TotalMeetings`) }} {{ leadsStatisticDealMeetingsLeadsChartData.totalMeetings }}</span>
          </div>
          <div v-show="pageKind" class="chart-label">
            <span class="color has-background-success"></span>
            <span class="txt">{{ $t(`${kindPrefix}.Graphs.DealMeetingsLeads.TotalDeals`) }} {{ leadsStatisticDealMeetingsLeadsChartData.totalDeals }}</span>
          </div>
        </div>
        <div class="chart-container" v-if="lineChartOptions">
          <LeadsGraphLine :height="250" :chart-data="leadsStatisticDealMeetingsLeadsChartData.chartData" :options="lineChartOptions"
              ref="dealMeetingsLeadsChart" />
        </div>
      </div>
    </mq-layout>

    <div class="graphs-bottom-panel">
      <div class="graphs-roi">
        <span class="roi-label">{{ $t("Leads.Graphs.ROI") }}</span>
        <span class="roi-val">265(20%)</span>
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <span class="roi-help">
            <icon-base width="16" height="16" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
          </span>
          <template #content>
            <div v-html="$t('Leads.Graphs.ROITooltip')"></div>
          </template>
        </b-tooltip>
      </div>
      <mq-layout class="graphs-view-tabs" mq="lg">
        <div class="tab" :class="graphActive === 0 ? 'is-active' : ''" @click="setLeadsGraphActive(0, ChartType.LeadsChannelMetadataType)">
          <icon-base width="20" height="20" view-box="0 0 20 20" icon-name="chart-pie"><icon-chart-pie /></icon-base>
          <span>{{ $t("Leads.Graphs.PiePanel") }}</span>
        </div>
        <div class="tab" :class="graphActive === 1 ? 'is-active' : ''" @click="setLeadsGraphActive(1, ChartType.LeadsStatisticDealMeetingsLeads)">
          <icon-base width="22" height="12" view-box="0 0 22 12" icon-name="chart-line"><icon-chart-line /></icon-base>
          <span>{{ $t("Leads.Graphs.LinePanel") }}</span>
        </div>
      </mq-layout>
      <div class="graphs-date-comparison">
        <b-button tag="a" href="#" class="is-icon">
          <icon-base width="23" height="21" view-box="0 0 23 21" icon-name="calendar-time"><icon-calendar-time /></icon-base>
          <span>{{ $t("Leads.Graphs.DateComparison") }}</span>
        </b-button>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ChartData, ChartDataSets, ChartOptions, ChartPoint } from "chart.js";
import "chartjs-plugin-datalabels";
import moment from "moment";
import { LoaderComponent } from "vue-loading-overlay";
import VueMq from "vue-mq";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { StyleValue } from "vue/types/jsx";
import { ChartType } from "@/models/ChartType";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import { DataSourceResult } from "@/models/DataSourceResult";
import { LeadsPageViewModel, RefreshGridMode } from "@/models/leads/Lead";
import { FilterCollection } from "@/models/FilterCollection";
import { CompanyPermission, LeadPermissionType } from "@/models/leads/CompanyPermission";
import { LeadsStats } from "@/models/leads/LeadsStats";
import { ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import CampaignService from "@/services/CampaignService";
import ChartService from "@/services/ChartService";
import HelperService from "@/services/HelperService";
import LeadService from "@/services/LeadService";
import { LeadStatistic, LeadStatisticExtended } from "@/models/leads/LeadStatistic";
import { LeadsPageKind } from "@/models/LeadsPageKind";
import { colorsByLeadStatus, LeadStatus } from "@/models/leads/LeadStatus";
import IconBase from "../IconBase.vue";
import LeadsGraphLine from "./LeadsGraphLine.vue";
import IconChartPie from "../icons/IconChartPie.vue";
import IconChartLine from "../icons/IconChartLine.vue";
import IconCalendarTime from "../icons/IconCalendarTime.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";
import LeadsGraphPie from "./LeadsGraphPie.vue";
import i18n from "../../i18n";

enum LineChartPeriod {
  Day,
  Week,
  Month,
  Year,
}

Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 992,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});

const namespace = "leadsModule";

@Component({
  components: {
    IconBase,
    IconChartPie,
    IconChartLine,
    IconCalendarTime,
    IconQuestionCircle,
    LeadsGraphLine,
    LeadsGraphPie,
  },
})
export default class LeadsGraphs extends Vue {

  @Prop({ required: true }) readonly kindPrefix!: string;
  @Prop({ required: true }) readonly pageKind!: LeadsPageKind;

  @Getter("additionalStatuses", { namespace }) additionalStatuses!: SelectListItem[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("columnsFilters", { namespace }) columnsFilters!: FilterCollection;
  @Getter("datePeriod", { namespace }) datePeriod!: Date[];
  @Getter("clientsDatePeriod", { namespace }) clientsDatePeriod!: Date[];
  @Getter("clientsSelectedCompaniesIds", { namespace }) clientsSelectedCompaniesIds!: number[];
  @Getter("leads", { namespace }) leads!: DataSourceResult;
  @Getter("leadsPageData", { namespace }) leadsPageData!: LeadsPageViewModel;
  @Getter("leadsStatisticByAdditionalStatus", { namespace }) leadsStatisticByAdditionalStatus!: LeadStatistic[];
  @Getter("leadsStatisticByCallStatus", { namespace }) leadsStatisticByCallStatus!: LeadStatistic[];
  @Getter("leadsStatisticByCampaigns", { namespace }) leadsStatisticByCampaigns!: LeadStatistic[];
  @Getter("leadsStatisticByPhoneAndForms", { namespace }) leadsStatisticByPhoneAndForms!: LeadStatistic[];
  @Getter("leadsStatisticBySaleStatus", { namespace }) leadsStatisticBySaleStatus!: LeadStatistic[];
  @Getter("leadsStatisticChannelMetadataType", { namespace }) leadsStatisticChannelMetadataType!: LeadStatistic[];
  @Getter("leadsStatisticDealMeetingsLeads", { namespace }) leadsStatisticDealMeetingsLeads!: LeadStatisticExtended[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Action("setColumnsFilters", { namespace }) setColumnsFilters!: (columnsFilters: FilterCollection) => void;
  @Action("setClientsSelectedAdditionalStatusesIds", { namespace }) setClientsSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setClientsSelectedCallStatusesIds", { namespace }) setClientsSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setClientsSelectedChannelMetadataTypesIds", { namespace }) setClientsSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setClientsSelectedChannelsIds", { namespace }) setClientsSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setClientsSelectedFoundMetadataTypesIds", { namespace }) setClientsSelectedFoundMetadataTypesIds!: (selectedFoundMetadataTypesIds: number[]) => void;
  @Action("setClientsSelectedSaleStatusesIds", { namespace }) setClientsSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;
  @Action("setNeedToRefreshLeadsGrid", { namespace }) setNeedToRefreshLeadsGrid!: (needToRefreshLeadsGrid: RefreshGridMode) => void;
  @Action("setSelectedAdditionalStatusesIds", { namespace }) setSelectedAdditionalStatusesIds!: (selectedAdditionalStatusesIds: number[]) => void;
  @Action("setSelectedCallStatusesIds", { namespace }) setSelectedCallStatusesIds!: (selectedCallStatusesIds: number[]) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedChannelsIds", { namespace }) setSelectedChannelsIds!: (selectedChannelsIds: number[]) => void;
  @Action("setSelectedFoundMetadataTypesIds", { namespace }) setSelectedFoundMetadataTypesIds!: (selectedFoundMetadataTypesIds: number[]) => void;
  @Action("setSelectedSaleStatusesIds", { namespace }) setSelectedSaleStatusesIds!: (selectedSaleStatusesIds: LeadStatus[]) => void;

  ChartType = ChartType;

  clientLeadsGraphActive = 0;
  leadsGraphActive = 0;

  lineChartOptions: ChartOptions | null = null;

  getPeriodDateFormat(lineChartPeriod: LineChartPeriod): string {
    switch (lineChartPeriod) {
      case LineChartPeriod.Month:
        return "MM/YYYY";
      case LineChartPeriod.Year:
        return "YYYY";
    }
    return "DD/MM/YYYY";
  }

  initlineChartOptions(lineChartPeriod: LineChartPeriod, stats?: LeadStatisticExtended[]) {
    this.lineChartOptions = {
      legend: {
        display: false,
      },
      layout: {
        padding: 0,
      },
      scales: {
        yAxes: [
          {
            gridLines: {
              display: true,
            },
            ticks: {
              stepSize: 10,
              suggestedMin: 0,
              suggestedMax: 10,
            },
          },
        ],
        xAxes: [
          {
            type: "time",
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              maxTicksLimit: 10000,
              callback: (
                value: number | string,
                index: number,
                values: number[] | string[],
              ): string | number | null | undefined => {
                if (!this.usedDatePeriod[0] && (!stats || stats.length === 0)) {
                  return "";
                }
                const startDate = moment(this.usedDatePeriod[0] ? this.usedDatePeriod[0] : stats![0].Day).startOf("day");
                const endDate = moment(this.usedDatePeriod[1] ? this.usedDatePeriod[1] : stats![stats!.length - 1].Day).startOf("day");
                const valueDate = moment(value, "DD/MM/YYYY").startOf("day");

                if (lineChartPeriod === LineChartPeriod.Day
                  || lineChartPeriod === LineChartPeriod.Week && !(index % 7)
                  || lineChartPeriod === LineChartPeriod.Month && valueDate.date() === 1
                  || lineChartPeriod === LineChartPeriod.Year && valueDate.date() === 1 && valueDate.month() === 0
                  || valueDate.isSame(endDate)
                ) {
                  let dateFormat: string = this.getPeriodDateFormat(lineChartPeriod);
                  return valueDate.format(dateFormat);
                }
              },
            },
            time: {
              unit: "day",
              displayFormats: {
                day: "DD/MM/YYYY",
              },
              tooltipFormat: this.getPeriodDateFormat(lineChartPeriod),
              parser: "YYYY-MM-DD"
            }
          },
        ],
      },
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        point: {
          radius: 2,
        },
      },
      animation: {
        duration: 0,
      },
      hover: {
        animationDuration: 200,
      },
      responsiveAnimationDuration: 0,
      plugins: {
        datalabels: {
          display: false,
        },
      },
      tooltips: {
        mode: "index"
      }
    };
    this.$nextTick(() => {
      if (this.$refs.dealMeetingsLeadsChart) {
        (this.$refs.dealMeetingsLeadsChart as any).refreshChart();
      }
    });
  }

  pieChartOptions: ChartOptions = {};
  stats: LeadsStats = {};

  leadsStatisticByAdditionalStatusChartData: ChartData = {};
  leadsStatisticByCallStatusChartData: ChartData = {};
  leadsStatisticByCampaignsChartData: ChartData = {};
  leadsStatisticByPhoneAndFormsChartData: ChartData = {};
  leadsStatisticBySaleStatusChartData: ChartData = {};
  leadsStatisticChannelMetadataTypeChartData: ChartData = {};
  leadsStatisticDealMeetingsLeadsChartData: LineChartData = {};

  channelMetadataTypeLoader?: LoaderComponent = undefined;
  dealMeetingsLeadsLoader?: LoaderComponent = undefined;
  leadsByAdditionalStatusLoader?: LoaderComponent = undefined;
  leadsByCallStatusLoader?: LoaderComponent = undefined;
  leadsByCampaignsLoader?: LoaderComponent = undefined;
  leadsByPhoneAndFormsLoader?: LoaderComponent = undefined;
  leadsBySaleStatusLoader?: LoaderComponent = undefined;

  //#region Watches

  @Watch("leadsStatisticByAdditionalStatus", { immediate: true })
  onLeadsStatisticByAdditionalStatusChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.leadsByAdditionalStatusLoader = 
        this.toggleGraphLoader(newStats === null, this.leadsByAdditionalStatusLoader, this.$refs.leadsByAdditionalStatusContainer as Element);
    this.leadsStatisticByAdditionalStatusChartData = this.getChartData(newStats, ChartType.LeadsAdditionalStatus);
    if (this.$refs.byAdditionalStatusChart) {
      (this.$refs.byAdditionalStatusChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticByCallStatus", { immediate: true })
  onLeadsStatisticByCallStatusChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.leadsByCallStatusLoader =
        this.toggleGraphLoader(newStats === null, this.leadsByCallStatusLoader, this.$refs.leadsByCallStatusContainer as Element);
    this.leadsStatisticByCallStatusChartData = this.getChartData(newStats, ChartType.LeadsCallStatus);
    if (this.$refs.byCallStatusChart) {
      (this.$refs.byCallStatusChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticByCampaigns", { immediate: true })
  onLeadsStatisticByCampaignsChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.leadsByCampaignsLoader = 
        this.toggleGraphLoader(newStats === null, this.leadsByCampaignsLoader, this.$refs.leadsByCampaignsContainer as Element);
    this.leadsStatisticByCampaignsChartData = this.getChartData(newStats, ChartType.LeadsCampaigns);
    if (this.$refs.byCampaignsChart) {
      (this.$refs.byCampaignsChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticByPhoneAndForms", { immediate: true })
  onLeadsStatisticByPhoneAndFormsChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.leadsByPhoneAndFormsLoader =
        this.toggleGraphLoader(newStats === null, this.leadsByPhoneAndFormsLoader, this.$refs.leadsByPhoneAndFormsContainer as Element);
    this.leadsStatisticByPhoneAndFormsChartData = this.getChartData(newStats, ChartType.LeadsPhoneAndForms);
    if (this.$refs.byPhoneAndFormsChart) {
      (this.$refs.byPhoneAndFormsChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticBySaleStatus", { immediate: true })
  onLeadsStatisticBySaleStatusChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.leadsBySaleStatusLoader =
      this.toggleGraphLoader(newStats === null, this.leadsBySaleStatusLoader, this.$refs.leadsBySaleStatusContainer as Element);

    if (newStats) {
      newStats.forEach((stat: LeadStatistic) => {
        stat.Color = colorsByLeadStatus[LeadStatus[stat.Id as LeadStatus] as keyof typeof colorsByLeadStatus];
      });
    }
    
    const chartData: ChartData = this.getChartData(newStats, ChartType.LeadsSaleStatus);
    let dealsIndex: number | undefined = chartData.labels?.indexOf("Sale Done");
    if (dealsIndex === -1) {
      dealsIndex = chartData.labels?.indexOf("עסקה נסגרה");
    }
    this.leadsStatisticBySaleStatusChartData = chartData;
    if (this.$refs.bySaleStatusChart) {
      (this.$refs.bySaleStatusChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticChannelMetadataType", { immediate: true })
  onLeadsStatisticChannelMetadataTypeChange(newStats: LeadStatistic[], oldStats: LeadStatistic[]): void {
    this.channelMetadataTypeLoader =
        this.toggleGraphLoader(newStats === null, this.channelMetadataTypeLoader, this.$refs.channelMetadataTypeContainer as Element);
    this.leadsStatisticChannelMetadataTypeChartData = this.getChartData(newStats, ChartType.LeadsChannelMetadataType);
    if (this.$refs.byChannelMetadataTypeChart) {
      (this.$refs.byChannelMetadataTypeChart as any).refreshChart();
    }
  }

  @Watch("leadsStatisticDealMeetingsLeads", { immediate: true })
  onLeadsStatisticDealMeetingsLeadsChange(newStats: LeadStatisticExtended[], oldStats: LeadStatisticExtended[]): void {
    this.dealMeetingsLeadsLoader =
        this.toggleGraphLoader(newStats === null, this.dealMeetingsLeadsLoader, this.$refs.dealMeetingsLeadsContainer as Element);

    this.leadsStatisticDealMeetingsLeadsChartData = this.getLineChartData(newStats);
    let startDate: moment.Moment | null = null;
    if (this.usedDatePeriod[0] || newStats !== null && newStats.length > 0) {
      startDate = moment(this.usedDatePeriod[0] ? this.usedDatePeriod[0] : newStats[0].Day).startOf("day");
    }
    let endDate: moment.Moment | null = null;
    if (this.usedDatePeriod[1] || newStats !== null && newStats.length > 0) {
      endDate = moment(this.usedDatePeriod[1] ? this.usedDatePeriod[1] : newStats[newStats.length - 1].Day).startOf("day");
    }
    let lineChartPeriod = this.getLineChartPeriod(startDate, endDate);
    this.initlineChartOptions(lineChartPeriod, newStats);
  }

  //#endregion Watches


  //#region Getters

  get cssVars(): StyleValue | undefined {
    return this.pageKind ?
    { 
      ['--flex-value' as any] : '0 0 16.6667%',
      ['--flex-value-max-width-1399px' as any] : '0 0 33.3333%' 
    } :
    {
      ['--flex-value' as any] : '0 0 25%',
      ['--flex-value-max-width-1399px' as any] : '0 0 50%' 
    }
  }

  get graphActive(): number {
    return this.pageKind ? this.clientLeadsGraphActive : this.leadsGraphActive;
  }

  get showCampaignNameInLeads(): boolean {
    return !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.CampaignNameInLeads);
  }

  get showChannelMetadataType(): boolean {
    return this.leadsPageData && !this.leadsPageData?.ActiveRestictions?.some((i: CompanyPermission) => i.Restriction === LeadPermissionType.Source);
  }

  //#endregion Getters


  //#region Lifecycle

  mounted(): void {
    this.initlineChartOptions(LineChartPeriod.Day);
  }

  //#endregion Lifecycle


  //#region Handlers

  onGraphLabelClick(chartType: ChartType, label: string): void {
    this.applyGraphClickFilters(chartType, label);
  }

  //#endregion Handlers


  //#region Private methods

  // Apply filters when clicked on chart element. This method linked to method "applyGraphClickFiltersCheckCanHover"
  applyGraphClickFilters(chartType: ChartType, label: string, id?: string | undefined) {
    if (chartType === ChartType.LeadsAdditionalStatus) {
      if (this.usedSelectedCompaniesIds.length > 0) {
        const additionalStatus: SelectListItem | undefined = this.additionalStatuses.find(i => i.Text === label);
        if (additionalStatus) {
          this.setUsedSelectedAdditionalStatusesIds([+additionalStatus.Value]);
        }
      } else {
        HelperService.showMessage("", i18n.t("Leads.Graphs.SelectCompany").toString());
      }
    } else if (chartType === ChartType.LeadsCallStatus) {
      const availableCallStatuses: MultiselectItem[] = LeadService.getCallStatuses();
      const callStatusItem: MultiselectItem | undefined = availableCallStatuses.find(i => i.Title === label);
      if (callStatusItem) {
        this.setUsedSelectedCallStatusesIds([+callStatusItem.Id]);
      }
    } else if (chartType === ChartType.LeadsCampaigns) {
      const channel: ChannelMultiselectItem | undefined = this.channels.find(i => i.Id.toString() === id);
      if (channel) {
        this.setUsedSelectedChannelsIds([+channel.Id]);
      } else {
        HelperService.showMessage("", i18n.t("Leads.Graphs.SelectClient").toString());     
      }
    } else if (chartType === ChartType.LeadsChannelMetadataType) {
      if (label === i18n.t("Enums.ChannelMetadataType.Other")) {
        HelperService.showMessage("", i18n.t("Leads.Graphs.CannotFilterBy", { FILTER: i18n.t("Enums.ChannelMetadataType.Other") }).toString());
      } else {
        const channelMetadataTypes: MultiselectItem[] = CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads);
        const channelMetadataType: MultiselectItem | undefined = channelMetadataTypes.find(i => i.Title.toLowerCase() === label.toLowerCase());
        if (channelMetadataType) {
          this.setUsedSelectedChannelMetadataTypesIds([+channelMetadataType.Id]);
        }
      }
    } else if (chartType === ChartType.LeadsPhoneAndForms) {
      const selectedFoundMetadataTypes: ChannelType[] = [];
      switch (label) {
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.FormLeads"):
          selectedFoundMetadataTypes.push(ChannelType.FormLeads);
          break;
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.PhoneLeads"):
          selectedFoundMetadataTypes.push(ChannelType.Phone);
          break;
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.WhatsAppLeads"):
          selectedFoundMetadataTypes.push(ChannelType.WhatsAppOrganic);
          break;
      }
      this.setUsedSelectedFoundMetadataTypesIds(selectedFoundMetadataTypes);
    } else if (chartType === ChartType.LeadsSaleStatus) {
      const availableSaleStatuses: MultiselectItem[] = LeadService.getAvailableSaleStatuses();
      const saleStatusItem: MultiselectItem | undefined = availableSaleStatuses.find(i => i.Title === label);
      if (saleStatusItem) {
        this.setUsedSelectedSaleStatusesIds([+saleStatusItem.Id]);
      }
    }
  }

  // Check if mouse pointer will look as hand when hover over chart. This method linked to method "applyGraphClickFilters"
  applyGraphClickFiltersCheckCanHover(chartType: ChartType, label: string, id?: string | undefined): boolean {
    if (chartType === ChartType.LeadsAdditionalStatus) {
      if (this.usedSelectedCompaniesIds.length > 0) {
        const additionalStatus: SelectListItem | undefined = this.additionalStatuses.find(i => i.Text === label);
        return !!additionalStatus;
      }
    } else if (chartType === ChartType.LeadsCallStatus) {
      const availableCallStatuses: MultiselectItem[] = LeadService.getCallStatuses();
      const callStatusItem: MultiselectItem | undefined = availableCallStatuses.find(i => i.Title === label);
      return !!callStatusItem;
    } else if (chartType === ChartType.LeadsCampaigns) {
      const channel: ChannelMultiselectItem | undefined = this.channels.find(i => i.Id.toString() === id);
      return !!channel;
    } else if (chartType === ChartType.LeadsChannelMetadataType) {
      if (label !== i18n.t("Enums.ChannelMetadataType.Other")) {
        const channelMetadataTypes: MultiselectItem[] = CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads);
        const channelMetadataType: MultiselectItem | undefined = channelMetadataTypes.find(i => i.Title.toLowerCase() === label.toLowerCase());
        return !!channelMetadataType;
      }
    } else if (chartType === ChartType.LeadsPhoneAndForms) {
      const selectedFoundMetadataTypes: ChannelType[] = [];
      switch (label) {
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.FormLeads"):
          selectedFoundMetadataTypes.push(ChannelType.FormLeads);
          break;
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.PhoneLeads"):
          selectedFoundMetadataTypes.push(ChannelType.Phone);
          break;
        case i18n.t("Leads.Graphs.LeadsByPhoneAndForms.WhatsAppLeads"):
          selectedFoundMetadataTypes.push(ChannelType.WhatsAppOrganic);
          break;
      }
      return selectedFoundMetadataTypes.length > 0;
    } else if (chartType === ChartType.LeadsSaleStatus) {
      const availableSaleStatuses: MultiselectItem[] = LeadService.getAvailableSaleStatuses();
      const saleStatusItem: MultiselectItem | undefined = availableSaleStatuses.find(i => i.Title === label);
      return !!saleStatusItem;
    }
    return false;
  }

  generatePieChartOptions(chartEl: Vue, chartType: ChartType): ChartOptions | undefined {
    return ChartService.generatePieChartOptions(chartEl, chartType, this.applyGraphClickFilters, this.applyGraphClickFiltersCheckCanHover);
  }

  getChartData(leadStats: LeadStatistic[], chartType: ChartType): ChartData {
    if (leadStats === null) {
      leadStats = [];
    }
    switch (chartType) {
      case ChartType.LeadsCampaigns:
        this.stats.LeadsByCampaignsCount = 0;
        break;
      case ChartType.LeadsChannelMetadataType:
        this.stats.LeadsByChannelMetadataTypeCount = 0;
        break;
    }
    leadStats.forEach((i: LeadStatistic) => {
      if (!i.Value) {
        return;
      }
      if (chartType === ChartType.LeadsCampaigns && this.stats.LeadsByCampaignsCount !== undefined) {
        this.stats.LeadsByCampaignsCount += +i.Value;
      } else if (chartType === ChartType.LeadsChannelMetadataType && this.stats.LeadsByChannelMetadataTypeCount !== undefined) {
        this.stats.LeadsByChannelMetadataTypeCount += +i.Value;
      }
    });
    let statCount = 0;
    switch (chartType) {
      case ChartType.LeadsCampaigns:
        statCount = this.stats.LeadsByCampaignsCount || 0;
        break;
      case ChartType.LeadsChannelMetadataType:
        statCount = this.stats.LeadsByChannelMetadataTypeCount || 0;
        break;
    }
    const otherMaxPercent = 2;  // all stats less than this in percent will be in "Other" category
    const otherMaxCount: number = statCount / 100 * otherMaxPercent;
    const newStats = leadStats.filter((i: LeadStatistic) => {
      switch (chartType) {
        case ChartType.LeadsCampaigns:
          return i.Value && i.Value >= otherMaxCount;
        case ChartType.LeadsChannelMetadataType:
          return i.Value && i.Value >= otherMaxCount;
        default:
          return true;
      }
    });
    const otherStats = leadStats.filter((i: LeadStatistic) => i.Value && i.Value < otherMaxCount).sort((a: LeadStatistic, b: LeadStatistic) => {
      return +b.Value - +a.Value;
    });
    const otherColor = "#435c65";
    if (otherStats.length > 0) {
      const MAX_OTHER_ITEMS = 10;
      const otherStatsTop = otherStats.slice(0, MAX_OTHER_ITEMS);
      let otherCount: number = otherStats.reduce((prevValue: number, stat: LeadStatistic) => {
        switch (chartType) {
          case ChartType.LeadsCampaigns:
            return stat.Value ? prevValue + +stat.Value : 0;
          case ChartType.LeadsChannelMetadataType:
            return stat.Value ? prevValue + +stat.Value : 0;
          default:
            return 0;
        }
      }, 0);
      let otherTitle = "";
      otherStatsTop.forEach((stat: LeadStatistic) => {
        otherTitle += `${stat.Text}: ${stat.Value}<br />`;
      });
      if (otherStats.length - MAX_OTHER_ITEMS > 0) {
        otherTitle += i18n.t("LeadsGraphs.LeadsByCampaigns.Others", { OTHERS_COUNT: otherStats.length - MAX_OTHER_ITEMS }).toString() + "<br />";
      }
      otherTitle += i18n.t("LeadsGraphs.LeadsByCampaigns.TotalLeads").toString();
      
      if (otherCount > 0) {
        otherCount = parseFloat(otherCount.toFixed(2));
        const otherStat: LeadStatistic = JSON.parse(JSON.stringify(leadStats[0]));
        otherStat.Text = otherTitle;
        otherStat.Color = otherColor;
        otherStat.Id = 0;
        switch (chartType) {
          case ChartType.LeadsCampaigns:
            otherStat.Value = otherCount;
            break;
          case ChartType.LeadsChannelMetadataType:
            otherStat.Value = otherCount;
            break;
        }
        newStats.push(otherStat);
      }
    }

    if (newStats.length > 0 && !newStats[0].Color) {
      var predefinedColors = ["#0f69c9", "#ff9724", "#0093d0", "#269339", "#de473c", "#66bee3"];
      for (let i = 0; i < newStats.length; i++) {
        if (newStats[i].Color != otherColor) {
          newStats[i].Color = predefinedColors[i % predefinedColors.length];
        }
      }
      // so color of first element will not be the same as last
      if (newStats.length > predefinedColors.length && newStats.length % predefinedColors.length === 1) {
        newStats[newStats.length - 1].Color = otherColor;
      }
    }
    const colors: string[] = newStats.map((i) => i.Color);
    const data: number[] = newStats.map((i) => i.Value);
    const labels: string[] = newStats.map((i) => i.Text);
    const chahnelIds: string[] = newStats.map((i) => i.Id?.toString());
    return {
      datasets: [
        {
          backgroundColor: colors,
          data,
        },
        {
          backgroundColor: chahnelIds,
          hidden: true,
        },
      ],
      labels,
    };
  }

  getChartLabelText(label: string): string {
    return label.indexOf("<br />") === -1 ? label : i18n.t("Enums.ChannelMetadataType.Other").toString();
  }

  getLineChartPeriod(firstDate: moment.Moment | null, lastDate: moment.Moment | null): LineChartPeriod {
    if (!firstDate || !lastDate) {
      return LineChartPeriod.Year;
    }
    const diffInDays = lastDate.diff(firstDate, "days");
    const diffInMonths = lastDate.diff(firstDate, "months");
    const diffInYears = lastDate.diff(firstDate, "years");
    if (diffInDays <= 7) {
      return LineChartPeriod.Day;
    } else if (diffInMonths < 1) {
      return LineChartPeriod.Week;
    } else if (diffInYears < 2) {
      return LineChartPeriod.Month;
    } else if (diffInYears >= 2) {
      return LineChartPeriod.Year;
    }
    return LineChartPeriod.Day;
  }

  getLineChartData(stats: LeadStatisticExtended[]): LineChartData {
    const colors: string[] = [];
    const canvas = document.getElementById("line-chart") as HTMLCanvasElement;
    let gradient: CanvasGradient | undefined = undefined;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      gradient = ctx?.createLinearGradient(0, 0, 0, 200);
      gradient?.addColorStop(0, 'rgba(176, 217, 255, 1)');   
      gradient?.addColorStop(1, 'rgba(176, 217, 255, 0)');
    }
    const leadsDataset: ChartDataSets = {
      backgroundColor: gradient,
      borderColor: "#0093d0",
      borderWidth: 2,
      fill: true,
      label: i18n.t("Leads.Graphs.Leads").toString(),
    };
    const dealsDataset: ChartDataSets = {
      borderColor: "#269339",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Leads.Graphs.Deals").toString(),
    };
    const meatingsDataset: ChartDataSets = {
      borderColor: "#ff9724",
      borderWidth: 2,
      fill: false,
      label: i18n.t("Leads.Graphs.Meetings").toString(),
    };
    const labels: string[] = [];
    if (stats === null) {
      stats = [];
    }
    if (stats.length > 0) {
      const leadsData: ChartPoint[] = [];
      const dealsData: ChartPoint[] = [];
      const meetingsData: ChartPoint[] = [];

      let statsDate = moment(this.usedDatePeriod[0] ? this.usedDatePeriod[0] : stats[0].Day).startOf("day");
      const statsFirstDate = moment(this.usedDatePeriod[0] ? this.usedDatePeriod[0] : stats[0].Day).startOf("day");
      const statsLastDate = moment(this.usedDatePeriod[1] ? this.usedDatePeriod[1] : stats[stats.length - 1].Day).startOf("day");
      let lineChartPeriod = this.getLineChartPeriod(statsFirstDate, statsLastDate);

      if (lineChartPeriod === LineChartPeriod.Month && statsDate.date() !== 1) {
        statsDate.date(1);
      } else if (lineChartPeriod === LineChartPeriod.Year && (statsDate.date() !== 1 || statsDate.month() !== 0)) {
        statsDate.date(1);
        statsDate.month(0);
      }

      while (statsDate <= statsLastDate) {
        let stat = stats.filter(i => moment(i.Day).startOf("day").isSame(statsDate))[0];
        if (!stat) {
          let addZeroValue = false;

          if (lineChartPeriod === LineChartPeriod.Day) {
            addZeroValue = true;
          } else if (lineChartPeriod === LineChartPeriod.Week) {
            const diffInDaysCurrent = statsDate.diff(statsFirstDate, "days");
            if (diffInDaysCurrent % 7 === 0) {
              addZeroValue = true;
            }
          }

          if (lineChartPeriod !== LineChartPeriod.Month && lineChartPeriod !== LineChartPeriod.Year && statsDate.isSame(statsLastDate)) {
            addZeroValue = true;
          }

          if (addZeroValue) {
            stat = {
              Day: statsDate.toDate(),
              Deals: 0,
              Leads: 0,
              Meetings: 0,
              DealsAmount: 0,
              DayString: "",
              DayStringShort: ""
            };
          }
        }
        if (stat) {
          const x: string = moment(stat.Day).format("YYYY-MM-DD");
          leadsData.push({
            x,
            y: stat.Leads,
          });
          dealsData.push({
            x,
            y: stat.Deals,
          });
          meetingsData.push({
            x,
            y: stat.Meetings,
          });
        }
        switch (lineChartPeriod) {
          case LineChartPeriod.Month:
            statsDate.add(1, "months");
            break;
          case LineChartPeriod.Year:
            statsDate.add(1, "years");
            break;
          default:
            statsDate.add(1, "days");
            break;
        }
      }
      leadsDataset.data = leadsData;
      dealsDataset.data = dealsData;
      meatingsDataset.data = meetingsData;
      if (this.lineChartOptions && this.lineChartOptions!.scales && this.lineChartOptions!.scales.yAxes && this.lineChartOptions!.scales.yAxes[0].ticks) {
        this.lineChartOptions!.scales.yAxes[0].ticks.suggestedMax = Math.max(...[...stats.map((i) => i.Leads), ...stats.map((i) => i.Deals), ...stats.map((i) => i.Meetings)]);
      }
    }
    return {
      chartData: {
        datasets: this.pageKind ? [leadsDataset, dealsDataset, meatingsDataset] : [leadsDataset],
        labels,
      },
      totalDeals: stats.map((i) => i.Deals).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalLeads: stats.map((i) => i.Leads).reduce((partialSum: number, a: number) => partialSum + a, 0),
      totalMeetings: stats.map((i) => i.Meetings).reduce((partialSum: number, a: number) => partialSum + a, 0),
    };
  }

  getSumOfStatsValues(stats: LeadStatistic[], filterValue = 0): number {
    if (stats) {
      if (filterValue) {
        stats = stats.filter((i: LeadStatistic) => i.Id === filterValue);
      }
      return stats.map((i) => i.Value as number).reduce((partialSum: number, a: number) => partialSum + a, 0);
    } else {
      return 0;
    }
  }

  getTotalAmountOfLeadsStatisticDealMeetingsLeads(): number {
    if (this.leadsStatisticDealMeetingsLeads) {
        return this.leadsStatisticDealMeetingsLeads.map(x => x.DealsAmount).reduce((sum, currentLead) => sum + currentLead, 0);
    }
    return 0;
  }

  getTotalDealCountOfLeadsStatisticDealMeetingsLeads(): number {
    if (this.leadsStatisticDealMeetingsLeads) {
      return this.leadsStatisticDealMeetingsLeads.map(x => x.Deals).reduce((sum, currentLead) => sum + currentLead, 0);
    }
    return 0;
  }

  getTotalMeetingCountOfLeadsStatisticDealMeetingsLeads(): number {
    if (this.leadsStatisticDealMeetingsLeads) {
      return this.leadsStatisticDealMeetingsLeads.map(x => x.Meetings).reduce((sum, currentLead) => sum + currentLead, 0);
    }
    return 0;
  }

  setLeadsGraphActive(value: number, chartType: ChartType) {
    if (this.pageKind){
      this.clientLeadsGraphActive = value;
    } else {
      this.leadsGraphActive = value;

    }
    this.$nextTick(() => {
      switch (chartType) {
        case ChartType.LeadsStatisticDealMeetingsLeads:
          (this.$refs.dealMeetingsLeadsChart as any).refreshChart();
          break;
        default:
          (this.$refs.byAdditionalStatusChart as any).refreshChart();
          (this.$refs.byCallStatusChart as any).refreshChart();
          (this.$refs.byCampaignsChart as any).refreshChart();
          (this.$refs.byChannelMetadataTypeChart as any).refreshChart();
          (this.$refs.byPhoneAndFormsChart as any).refreshChart();
          (this.$refs.bySaleStatusChart as any).refreshChart();
          break;
      }
    });
  }

  toggleGraphLoader(show: boolean, loaderComponent: LoaderComponent | undefined, container: Element) {
    if (!container) {
      return;
    }
    if (show) {
      loaderComponent = this.$loading.show({
        container
      });
    } else if (loaderComponent) {
      loaderComponent.hide();
    }
    return loaderComponent;
  }

  //#region Getters based on page kind

  get usedDatePeriod(): Date[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsDatePeriod;
      case LeadsPageKind.Leads:
        return this.datePeriod;
    }
  }

  get usedSelectedCompaniesIds(): number[] {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        return this.clientsSelectedCompaniesIds;
      case LeadsPageKind.Leads:
        return this.selectedCompaniesIds;
    }
  }

  //#endregion Getters based on page kind

  //#region Setters based on page kind

  setUsedSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedAdditionalStatusesIds(selectedAdditionalStatusesIds);
        break;
    }
  }

  setUsedSelectedCallStatusesIds(selectedCallStatusesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedCallStatusesIds(selectedCallStatusesIds);
        break;
    }
  }

  setUsedSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelMetadataTypesIds(selectedChannelMetadataTypesIds);
        break;
    }
  }
  
  setUsedSelectedChannelsIds(selectedChannelsIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedChannelsIds(selectedChannelsIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedChannelsIds(selectedChannelsIds);
        break;
    }
  }

  setUsedSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds: number[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedFoundMetadataTypesIds(selectedFoundMetadataTypesIds);
        break;
    }
  }

  setUsedSelectedSaleStatusesIds(selectedSaleStatusesIds: LeadStatus[]): void {
    switch (this.pageKind) {
      case LeadsPageKind.Clients:
        this.setClientsSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
      case LeadsPageKind.Leads:
        this.setSelectedSaleStatusesIds(selectedSaleStatusesIds);
        break;
    }
  }

  //#endregion Setters based on page kind

  //#endregion Private methods
}

interface LineChartData {
  totalDeals?: number;
  totalLeads?: number;
  totalMeetings?: number;
  chartData?: ChartData;
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.section-graphs {
  background: #fff;
  border: 1px solid #d3d6e2;
  border-radius: 4px;
  margin-bottom: 30px;
  .graph {
    &.graph-pie {
      display: flex;
      align-items: stretch;
      @media (max-width: 991px) {
        width: 100%;
      }
      .wblock {
        width: 100%;
        padding: 20px;
      }
    }
  }

  .chart-list {
    width: 100%;
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    margin: 0 -1px -1px 0;
    @media (max-width: 575px) {
      display: block;
    }
    .chart-item {
      padding: 10px 24px;
      width: 16.6667%;
      flex: var(--flex-value);
      border-bottom: 1px solid #d3d6e2;
      border-right: 1px solid #d3d6e2;
      position: relative;
      @media (max-width: 1599px) {
        padding: 10px 16px;
      }
      @media (max-width: 1399px) {
        width: 33.3333%;
        flex: var(--flex-value-max-width-1399px);
        @media (resolution: 120dpi) {
          width: 16.6667%;
          flex: 0 0 16.6667%;
        }
      }
      @media (max-width: 1199px) and (resolution: 120dpi) {
        width: 33.3333%;
        flex: 0 0 33.3333%;
      }
      @media (max-width: 991px) {
        width: 50%;
        flex: 0 0 50%;
        padding: 10px 16px 20px;
      }
      @media (max-width: 575px) {
        width: 100%;
      }
      .chart-title {
        font-size: 17px;
        font-weight: 600;
        min-height: 60px;
        .chart-title-t {
          display: block;
        }
        .chart-title-b {
          display: block;
          @media (max-width: 991px) {
            display: none;
          }
          &.text-blue {
            color: $primary;
          }
          &.text-yellow {
            color: $warning;

            & > .b-tooltip {
              color: $dark;
              margin-inline-end: .2rem;
            }
          }
          &.text-green {
            color: $success;

            & > .b-tooltip {
              color: $dark;
              margin-inline-end: .2rem;
            }
          }
        }
        
        .chart-title-b-m {
          color: #aaa;
          font-size: 16px;
          display: block;
          line-height: 1.2;
        }
        .chart-title-sm {
          color: $dark;
          font-size: .9rem;
        }
      }
      .chart-titles {
        display: flex;
        .chart-title {
          padding: 0 0 5px 5px;
          &.chart-title-second {
            margin-right: auto;
            text-align: left;
            padding: 0 5px 5px 0;
            @media (max-width: 991px) {
              display: none;
            }
          }
        }
      }
    }
    .chart-container {
      position: relative;
      justify-content: center;
      margin: 0 auto 20px;
    }

    .chart-labels {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .chart-label {
        display: flex;
        align-items: center;
        margin: 0 7px 5px;
        .color {
          width: 6px;
          height: 6px;
          flex: 0 0 6px;
          margin: 2px 0 0 5px;
        }
        .txt {
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          flex: 1;
        }
      }
    }
  }

  .graph {
    &.graph-line {
      .chart-item {
        padding: 40px 20px 20px;
        display: flex;
        position: relative;
      }
      .chart-labels {
        padding: 0 10px 0 45px;
        flex: 0 0 220px;
        width: 220px;
        .chart-label {
          display: flex;
          align-items: center;
          margin: 0 0 5px;
          .color {
            width: 6px;
            height: 6px;
            flex: 0 0 6px;
            margin: 2px 0 0 9px;
          }
          .txt {
            font-size: 14px;
            font-weight: 600;
            flex: 1;
          }
        }
      }
      .chart-container {
        flex: 1;
        width: 100%;
        height: 250px;
      }
    }
  }

  .graphs-bottom-panel {
    display: flex;
    align-items: center;
    padding: 18px 21px;
    border-top: 1px solid $lightd;
    @media (max-width: 991px) {
      display: block;
      padding: 0;
    }
    .graphs-roi {
      display: flex;
      font-size: 18px;
      align-items: center;
      margin: 0 3px 0 auto;
      min-width: 300px;
      @media (max-width: 991px) {
        padding: 15px 25px;
        border-bottom: 1px solid $lightd;
        margin: 0;
        min-width: 200px;
      }

      div, span {
        display: none;
      }

      .roi-label {
        margin: 0 0 0 7px;
        font-weight: 600;
      }
      .roi-val {
        margin-left: 10px;
      }
      .roi-help {
        line-height: 0;
        color: $dark4;
        cursor: pointer;
        transition: all 0.2s;
      }
    }
    .graphs-view-tabs {
      display: flex;
      align-items: center;
      .tab {
        margin: 0 15px;
        display: flex;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
        font-weight: 600;
        transition: all 0.2s;
        &:hover {
          color: #666;
        }
        .icon-w {
          margin-left: 9px;
        }
        &.is-active {
          color: $primary;
        }
      }
    }
    .graphs-date-comparison {
      display: none;
      margin-right: auto;
      min-width: 300px;
      text-align: left;
      @media (max-width: 991px) {
        margin: 0;
        padding: 30px 25px;
        min-width: 200px;
      }
      @media (max-width: 359px) {
        padding: 20px 15px;
      }
      .button {
        @media (max-width: 991px) {
          width: 100%;
          font-size: 17px;
          height: 35px;
        }
      }
    }
  }
}

html[dir="ltr"] {
  .section-graphs {
    .chart-list {
      margin: 0 0 -1px -1px;
      .chart-item {
        border-right: none;
        border-left: 1px solid #d3d6e2;
        .chart-titles {
          .chart-title {
            padding: 0 5px 5px 0;
            &.chart-title-second {
              text-align: right;
              margin: 0 0 0 auto;
              padding: 0 0 5px 5px;
            }
          }
        }
      }
      .chart-labels {
        .chart-label {
          .color {
            margin: 2px 5px 0 0;
          }
        }
      }
    }
    .graph.graph-line {
      .chart-labels {
        padding: 0 45px 0 10px;
        .chart-label {
          .color {
            margin: 2px 9px 0 0;
          }
        }
      }
    }

    .graphs-bottom-panel {
      .graphs-roi {
        margin: 0 auto 0 3px;
        .roi-label {
          margin: 0 7px 0 0;
        }
        .roi-val {
          margin: 0 10px 0 0;
        }
      }
      .graphs-view-tabs {
        .tab {
          .icon-w {
            margin: 0 9px 0 0;
          }
        }
      }
      .graphs-date-comparison {
        margin: 0 0 0 auto;
        text-align: right;
      }
    }
  }
}
</style>

<style lang="scss">
.graphs-roi .b-tooltip.is-dark .tooltip-content {
  width: 500px;
  font-weight: normal;
  font-size: 16px;
  background: #303b41;
  padding: 15px 18px 18px;
  @media (max-width: 1199px) {
    width: auto;
    min-width: 280px;
  }
  @media (max-width: 479px) {
    left: -40px;
    transform: none;
  }
  &:before {
    border-width: 7px;
    @media (max-width: 479px) {
      left: 48px;
    }
  }
}
html[dir="ltr"] {
  .graphs-roi .b-tooltip.is-dark .tooltip-content {
    @media (max-width: 479px) {
      left: auto;
      right: -40px;
    }
    &:before {
      @media (max-width: 479px) {
        right: 34px;
        left: auto;
      }
    }
  }
}
</style>
